import { IReportType } from '../report-interfaces';
import Relatorio from '../Relatorio';
import { FieldsNames } from '../ReportFields';
import Field from '@tekvue/assets/interfaces/Field';

export default class RelatorioResumoMovimentoHierarquia implements IReportType {
  constructor(main: Relatorio) {
    this.main = main;
  }

  main!: Relatorio;

  name = 'Resumo Movimento - Hierarquia';
  value = 'resumo_movimento_hierarquia';

  defaultRow = {
    NRTIPOMOVIMENT: '1', // Mensal
    ZEBRADO: 'N',
    OMITIRLEGAL: 'N',
    INCLUIR13: 'N',
    OMITIRRESC: 'N',
    SODEMITIDO: 'N',
    IGNORAOCORR: 'N',
    MOSTRARDEMO: 'N',
    NRTIPOINCIDE: '',
    LISTALOTEVINCULO: '',
  }

  params = [
    {
      param: 'P_NRORG_PADRAO',
      required: true,
      defaultValue: '0',
    },
    {
      param: 'P_OCORRECAL',
      required: true,
      defaultValue: '1',
    },
    {
      param: 'P_MODALIDADECAL',
      required: true,
      defaultValue: '1'
    },
    {
      fieldName: 'NRTIPOHIERARQ',
      param: 'P_NRTIPOHIERARQ',
      required: true,
    },
    {
      fieldName: 'DTMESCOMPETENCIA',
      param: 'P_COMPETENCIA',
      required: true,
    },
    {
      fieldName: 'NRESTRUTLEGAL',
      param: 'P_ESTRUTURALEGAL',
    },
    {
      fieldName: 'NRESTRUTGEREN',
      param: 'P_ESTRUTURAGEREN',
    },
    {
      fieldName: 'NRTIPOMOVIMENT',
      param: 'P_TIPOMOVIMENTO',
      required: true,
      descriptionField: 'Mensal',
      valueField: '1',
    },
    {
      fieldName: 'NRTIPOHIERARQ',
      param: 'P_NRTIPOHIERARQ',
      required: true,
    },
    {
      fieldName: 'NRESTRUTSUPERIOR',
      param: 'P_NRESTRUTSUP',
    },
    {
      fieldName: 'ZEBRADO',
      param: 'ZEBRADO',
    },
    {
      fieldName: 'OMITIRVINCULOS',
      label: 'Omitir Vínculos',
      param: 'P_OMITIRVINCULOS',
    },
    {
      fieldName: 'OMITIRLEGAL',
      label: 'Omitir Resumo Legal',
      param: 'P_OMITIRLEGAL',
    },
    {
      fieldName: 'INCLUIR13',
      label: 'Incluir 13º Sal. no movimento',
      param: 'P_INCLUIR13',
    },
    {
      fieldName: 'OMITIRRESC',
      label: 'Omitir Data de Rescisão',
      param: 'P_OMITIRRESC',
    },
    {
      fieldName: 'SODEMITIDO',
      label: 'Somente Vínculos Demitidos',
      param: 'P_SODEMITIDO',
    },
    {
      fieldName: 'IGNORAOCORR',
      label: 'Ignorar Ocorrencias de Cálculo',
      param: 'P_IGNORAOCORR',
    },
    {
      fieldName: 'MOSTRARDEMO',
      label: 'Mostrar Eventos Demonstrativos',
      param: 'P_MOSTRARDEMO',
    },
    {
      fieldName: 'NRTIPOINCIDE',
      label: 'Eventos Ocultos do Tipo de Incidencia ',
      param: 'P_NRTIPOINCIDE',
    },
    {
      fieldName: 'NRVINCULOM',
      param: 'P_NRVINCULO',
    },
    {
      fieldName: 'BREAKBYFILES',
    },
    {
      fieldName: 'LISTALOTEVINCULO',
      param: 'P_LISTALOTEVINCULO',
    },
  ];

  get fields(): Field[] {
    return this.main && this.main.fields ? [
      this.main.dtCompetenciaField,
      this.main.tipoMovimentoField,
      this.estruturaLegalField,
      this.main.estruturaGerencialField,
      this.estruturaSuperiorField,
      this.vinculosField,
      this.main.fields[FieldsNames.OMITIR_VINCULOS],
      this.main.fields[FieldsNames.OMITIR_LEGAL],
      this.main.fields[FieldsNames.INCLUIR_13],
      this.main.fields[FieldsNames.OMITIR_RESCISAO],
      this.main.fields[FieldsNames.SO_DEMITIDO],
      this.main.ignorarOcorrField,
      this.main.fields[FieldsNames.MOSTRAR_EVENTOS_DEMONSTRATIVOS],
      this.main.fields[FieldsNames.TIPO_INCIDENCIA],
      this.main.zebradoField,
      this.main.fields[FieldsNames.BREAK_BY_FILES],
    ] : [];
  }

  private get vinculosField(): Field {
    return {
      ...this.main.vinculosField,
      required: false,
    };
  }

  private get estruturaSuperiorField(): Field {
    return {
      ...this.main.estruturaSuperiorOperadorField,
      required: true,
    };
  }

  private get estruturaLegalField(): Field {
    return {
      ...this.main.estruturaLegalField,
      required: false,
    };
  }

  onSelection = () => {
    this.main.informeRendimentosOnSelection();
    this.main.loadEstruturasSuperioresTipoHierarquiaInfo();
    this.main.loadTiposIncidencia();
  }
}
